// extracted by mini-css-extract-plugin
export default {"btop":"_1e05279e5e _047ba2acef _8491f2349f","icon":"_23e43acdfe _2beb319e87","btoppink":"a0d747f849 c36294ad14"};